module.exports = __webpack_public_path__ + "img/doc-personal.b5db7a25.svg";